var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{key:_vm.itemKey,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('add-field')}}},[_c('v-list-item-avatar',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.label))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.description)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }